import { FunctionComponent, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  CircularProgress,
  Button,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { displayValue } from "../../../helpers/TodayDate";
import SessionStorageService from "../../../services/StorageService";
import OBBasvuruListe from "../../../apis/OB/Get/OBBasvuruListe";
import ObBasvuruTuruListe from "../../../apis/OB/Get/ObBasvuruTuruListe";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import { useNavigate } from "react-router";

const Basvurularim: FunctionComponent<any> = (props) => {
  const [data, setData] = useState<any[]>([]);
  const [basvuruTuruListe, setBasvuruTuruListe] = useState<any[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedBasvuruTuru, setSelectedBasvuruTuru] = useState<string | null>(
    null
  );

  // Durum popup state
  const [durumPopup, setDurumPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const user = SessionStorageService.getUserInfo();
  const fetchData = () => {
    if(user){
      setIsLoading(true);
      ObBasvuruTuruListe.getObBasvuruTuruListeListe()
        .then((res) => {
          setBasvuruTuruListe(res.data);
          console.error("Error fetching data:", res.data);
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        });
      OBBasvuruListe.getOBBasvuruListe(Number(user.sicilKodu),
        selectedBasvuruTuru != null ? Number(selectedBasvuruTuru) : undefined,
        undefined
      )
        .then((res) => {
          setData(res.data);
          console.error("Error fetching data:", res.data);
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const navigate=useNavigate()
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };  const [userControlPopup, setUserControlPopup] = useState(false);
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {

    if (user == null) {

      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }

  }, []);
  // Durum popup handlers
  const handleDurumClick = (item: any) => {
    setSelectedItem(item);
    setDurumPopup(true);
  };

  const closeDurumPopup = () => {
    setDurumPopup(false);
  };

  const handleDialogExited = () => {
    setSelectedItem(null); 
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  return isLoad ? <>
    <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
    {userControlPopup ? (

      <AciklamaAndUserControlPopup
        open={userControlPopup}
        handleClose={closeUserControlPopup}
        isUserControlPopUp={true}
        description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
      />

    ) : null}
  </> :(
    <div style={{ width: "100%", padding: "0 5%", fontSize: "0.9rem" }}>
      {isLoading ? (
        <CircularProgress
          style={{ display: "block", margin: "auto", marginTop: "20%" }}
        />
      ) : (
        <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
          <div className="d-flex justify-content-between w-100 p-3">
            <TextField
              sx={{minWidth:'170px'}}
              className="mb-3"
              select
              label="Başvuru Türü"
              value={selectedBasvuruTuru}
              size="small"
              onChange={(e) => {
                setSelectedBasvuruTuru(e.target.value);
              }}
            >
              <MenuItem selected value={null as any}>
                {"Seçiniz.."}
              </MenuItem>
              {basvuruTuruListe.map((option: any) => (
                <MenuItem
                  key={option.basvuruTuruKodu}
                  value={option.basvuruTuruKodu}
                >
                  {option.basvuruTuruAdi}
                </MenuItem>
              ))}
            </TextField>
            <Button onClick={fetchData}>Ara</Button>
          </div>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Başvuru No</TableCell>
                <TableCell>Başvuru Tarihi</TableCell>
                <TableCell>Konu</TableCell>
                <TableCell>Durum</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{displayValue(item.basvuruNo)}</TableCell>
                    <TableCell>{displayValue(item.basvuruTarihi)}</TableCell>
                    <TableCell>{displayValue(item.konu)}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleDurumClick(item)}>
                        {item.durum || "Başvurunuz alındı"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[6, 8, 12]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )}
      {!isLoading && data.length === 0 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          Veri bulunamadı!
        </div>
      )}

      {/* Durum Popup */}
      <Dialog
        open={durumPopup}
        onClose={closeDurumPopup}
        TransitionProps={{
          onExited: handleDialogExited  // Animasyon bittikten sonra çalışır
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent style={{ padding: '20px' }}>
          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '16px',
            paddingBottom: '16px',
            borderBottom: '1px solid #e0e0e0'
          }}>
            <Typography variant="body2" style={{ fontWeight: 600, minWidth: '120px' }}>
              Durum
            </Typography>
            <Typography variant="body2">
              {selectedItem?.durum || "Başvurunuz Alındı"}
            </Typography>
          </div>

          <div>
            <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '12px' }}>
              Durum Açıklama
            </Typography>
            <div style={{
              border: '1px solid #ddd',
              padding: '12px',
              borderRadius: '4px',
              backgroundColor: '#f9f9f9',
              minHeight: '60px'
            }}>
              <Typography variant="body2" style={{ color: '#333', lineHeight: '1.6' }}>
                {selectedItem?.sonucAciklama || "Başvurunuzun ilk değerlendirmesi yapılıyor. Birimde olacak olan ilerlemeleri buradan takip edebilirsiniz."}
              </Typography>
            </div>
          </div>
        </DialogContent>

        <DialogActions style={{ padding: '12px 20px', justifyContent: 'center' }}>
          <Button
            onClick={closeDurumPopup}
            variant="contained"
            color="primary"
            style={{ minWidth: '120px' }}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Basvurularim;
